
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/privateAppsPanel/components/appDescription/appDescription.scss.css.virtualfile';
        module.exports = {"content":"_content_1006j_1","container":"_container_1006j_4"};